import { gql } from "graphql-request";
import { IMAGE_FRAGMENT } from "./fragments";

// Fetches all hotel areas along with key stations and hotel details
export const GET_HOTEL_AREAS = gql`
  ${IMAGE_FRAGMENT}
  query GetHotelAreas($locale: I18NLocaleCode) {
    japanAreas(locale: $locale, pagination: { limit: -1 }) {
      name: item_name
      latitude
      longitude
      selected_hotels
      key_stations_marked_cities {
        item_name
        display_name
        longitude
        latitude
        type
        documentId
        icon {
          cloudflare_url
        }
        preview_image {
          cloudflare_url
        }
      }
      hotels(pagination: { limit: -1 }) {
        name: item_name
        slug
        documentId
        hotel_images {
          desktop {
            media {
              ...ImageUrlProperties
            }
          }
        }
        properties {
          prefecture
          hotel_name
          brand
          latitude
          longitude
          adjust_longtitude
          adjust_latitude
        }
        redirect {
          external_url
        }
      }
    }
  }
`;

/**
 * LEAN version of GET_HOTEL_AREAS for MapSearchAsync
 * Removes hotel_images.desktop.media to reduce payload
 * Hotels within areas don't need image data for map display
 * Saves ~80-100KB compared to full GET_HOTEL_AREAS
 */
export const GET_HOTEL_AREAS_LEAN = gql`
  query GetHotelAreasLean($locale: I18NLocaleCode) {
    japanAreas(locale: $locale, pagination: { limit: -1 }) {
      name: item_name
      latitude
      longitude
      selected_hotels
      key_stations_marked_cities {
        item_name
        display_name
        longitude
        latitude
        type
        documentId
        icon {
          cloudflare_url
        }
        preview_image {
          cloudflare_url
        }
      }
      hotels(pagination: { limit: -1 }) {
        name: item_name
        slug
        documentId
        properties {
          prefecture
          hotel_name
          brand
          latitude
          longitude
          adjust_longtitude
          adjust_latitude
        }
        redirect {
          external_url
        }
      }
    }
  }
`;

// Retrieves brand icons and links for top, middle, and bottom brand sections
export const GET_HOTEL_BRANDS = gql`
  query topPageHotelBrandIcons(
    $locale: I18NLocaleCode
    $documentId: ID!
    $status: PublicationStatus
    $middleDocId: ID!
  ) {
    homeBrand(documentId: $documentId, locale: $locale, status: $status) {
      top_list_datasources {
        home_brands_top_list_datasources_crm_top_list_datasource_top_details {
          icon {
            cloudflare_url
            url
          }
          brand_url
        }
      }
      middle_list_datasources(filters: { documentId: { eq: $middleDocId } }) {
        icon {
          cloudflare_url
          url
        }
        hotel_button_link
      }
      bottom_list_datasources {
        documentId
        brand_details {
          icon {
            cloudflare_url
            url
          }
          brand_link
        }
      }
    }
  }
`;

// Fetches map text and filter modal labels for hotel map interface
export const GET_MAP_TEXT_DATASOURCE = gql`
  query GetMapTextDatasource($homeDatasourceDocumentId: ID!) {
    homeDatasource(documentId: $homeDatasourceDocumentId) {
      map_text_datasource {
        map {
          title
          filter_button_text
          search_result_field_text
          button_see_more_text
        }
        filter_modal {
          button_reset_text
          button_search_text
          filter_modal_title
          subtitle_brand
          subtitle_conditions
        }
      }
    }
  }
`;
